/* eslint-disable @typescript-eslint/ban-types */
import React from 'react'
import { Field as FinalField } from 'react-final-form'
import { ICondition } from './Type'

const ConditialField = <T extends {}>({
  when,
  children,
  condition,
  values,
}: ICondition<T>): React.ReactElement => {
  return (
    <FinalField name={when} subscription={{ value: true }}>
      {({ input: { value } }) => (condition(value, values) ? children : null)}
    </FinalField>
  )
}

export default ConditialField
